import React from 'react';
import ListItem from '../../list-items/ListItem';

import './LabelList.css'

const InputText = React.memo(props=>{
  return (
    <input
      name={props.name}
      type={props.type}
      className={props.className}
      id={props.id}
      size={props.size}
      onChange={props.onChange}
      value={props.value}
      placeholder={props.placeholder}
    />
  )
})

const LabelList = (props) => {
  return (
    <>
      <div className="labelListTit">그룹 목록</div>
      <div className="labelCreate">
        <InputText placeholder="생성할 그룹 명 입력" onChange={props.handleCreateInput} value={props.createLabelName} name="textfield" type="text" className="box" id="textfield" size="25" />
        {/* <a onClick={()=>props.createLabel()} className="button purple_line" style={{padding: "5px 15px", marginLeft: "4px"}}>생성</a> */}
        <a onClick={()=>props.createLabel()} className="button purple_line" style={{marginLeft: "4px"}}>생성</a>
      </div>
      <div className="labelGroup">
        <div className="overflow-component">
          {props.labelData && props.labelData.info.map( (item, index) => 
            <ListItem type={`${props.labelData.type}Setting`} key={item.name+index} item={item} index={index} handleClick={props.handleLabelListClick} />
          )}
          {/* {props.labelData && <ListItem type={`${props.labelData.type}Setting`} key={`null-label-item`} item={{name:'none', labelID: null}} index={0} handleClick={props.handleLabelListClick} /> } */}
        </div>
      </div>
    </>
  )
}

export default LabelList;